export const isTeamMemberInApprovers = (approvers, userId) => {
  let approversIds = approvers.map(item => item.id)

  return !!approversIds.find(approverId => approverId === userId)
}
